<template>
  <div style="padding: 30px;" >
	  
	  <p>欢迎使用拾光记APP（以下简称“本应用”或“我们”）。在您使用本应用服务的过程中，我们需要收集您的某些信息。为了保障您的权益，请您仔细阅读本协议，在确认充分理解并同意后再开始使用我们的服务。</p><p><br></p><p> 一、服务协议的接受及修改</p><p><br></p><p> 1.1 在使用我们的服务之前，请认真阅读并了解本协议的全部内容。一旦您进入我们的App页面并注册用户，即视为您已经充分理解、同意并接受本协议的全部条款和内容。如果您不同意接受本协议的任何内容，请勿使用我们的服务。</p><p><br></p><p> 1.2 我们保留随时修改或更新本协议内容的权利。修改或更新后的协议内容将公布在我们的官方网站上，且该修改或更新自公布之日起立即生效。如果您继续使用我们的服务，则视为您已经接受修改或更新后的协议内容。</p><p><br></p><p> 二、用户隐私</p><p><br></p><p> 2.1 我们承诺在收集、存储和使用您的个人信息时，遵循适用的法律和法规，并且采取必要的措施保护您的隐私。</p><p><br></p><p> 2.2 您使用本应用服务即表示您同意我们收集、存储、使用、披露和处理您的个人信息，包括但不限于您的姓名、性别、年龄、联系方式、设备型号、操作系统版本号等信息。</p><p><br></p><p> 2.3 我们不会将您的个人信息出售或租赁给第三方。</p><p><br></p><p> 三、服务内容及使用规则</p><p><br></p><p> 3.1 我们的服务内容包括但不限于：提供文字、图片、图文、信息发布等方面的应用服务。</p><p><br></p><p> 3.2 您应当遵守本应用的使用规则。禁止发布、传播、分享、储存任何违反中华人民共和国法律法规的信息，包括但不限于：色情、暴力、恐怖主义、反动等。</p><p><br></p><p> 3.3 您不得采用和谐、散布恶意、侮辱、泄露他人隐私等不当方式干扰我们的服务，包括但不限于发布垃圾信息、利用代码漏洞等恶意行为。</p><p><br></p><p> 3.4 您应按照合法、诚信、公平、公正的原则使用我们的服务，不得以非法、不当的方式获取或使用任何第三方信息，包括但不限于虚假广告、诈骗等。</p><p><br></p><p> 四、知识产权</p><p><br></p><p> 4.1 我们拥有我们提供的服务所涉及的所有知识产权，包括但不限于著作权、商标权、专利权等。未经我们的明确书面许可，您不得以任何形式使用或使用我们的知识产权。</p><p><br></p><p> 4.2 您使用本应用服务所产生的任何内容，包括但不限于文字、图片、音频、视频等内容，均受到相关法律法规的保护。未经我们的明确书面许可，您不得以任何形式使用或使用该内容。</p><p><br></p><p> 五、免责声明</p><p><br></p><p> 5.1 我们不能保证我们的服务一定能够满足您的需求，也不会由于使用我们的服务而导致的任何直接或间接损失负责。</p><p><br></p><p> 5.2 在法律允许范围内，我们不对因以下原因导致的任何直接或间接损失承担责任：无法使用我们的服务；未经授权的访问或更改数据；第三方通过我们的服务获取的信息；其他与我们的服务相关的事项。</p><p><br></p><p> 5.3 我们保留随时中断或终止本应用服务的权利，并不承担因服务中断或终止而产生的任何损失或责任。</p><p><br></p><p> 六、法律适用</p><p><br></p><p> 6.1 本协议的订立、效力、解释和争议解决均适用中华人民共和国的法律。</p><p><br></p><p> 6.2 本协议中任一条款的无效或不可执行不影响其余条款的效力，本协议应照常解释和执行。</p><p><br></p><p> 七、协议的解释</p><p><br></p><p> 7.1 应用服务指含本应用软件以及关联服务。</p><p><br></p><p> 7.2 我们指应用服务的运营方，具体详见服务App。</p><p><br></p><p> 7.3 用户是指使用应用服务的个人或组织。</p><p><br></p><p> 八、协议的生效和解释</p><p><br></p><p> 8.1 本协议条款的效力、解释、执行和争议的解决均适用中华人民共和国的法律。</p><p><br></p><p> 8.2 若您和我们就本协议或其它事项发生争议，双方均应首先通过友好协商的方式解决，如无法协商一致，您应向我们所在地的有管辖权的人民法院提起诉讼。</p><p><br></p><p> 8.3 本协议自您按照要求完成注册手续、获取应用服务的许可使用权之日起生效，除非本协议被终止，否则将持续有效。</p><p><br></p><p> 感谢您使用我们的应用服务！</p>
	  
	  
	  
	  </div>
</template>
<script>
    export default {
        name: 'Fruit',
        data () {
            return {
               delivery:[
                   {
                       img: require('../assets/other/定位图标.png'),
                       title: "自定义配送范围",
                       contents:["商家后台自定义配送范围"]
                   },{
                       img: require('../assets/other/骑车送.png'),
                       title: "支持自定义配送",
                       contents:["商家自己优选配送路径"]
                   },{
                       img: require('../assets/other/券.png'),
                       title: "线上优惠券福利",
                       contents:["各种优惠福利提升用户消费"]
                   }
               ]
            }
        }
    }
</script>

<style scoped>
  *{
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
  .delivery_border{
    height: auto;
    margin: 20px;
    width: 55%;
    /*border-radius: 6px;*/
    /*border: 1px solid #EBEEF5;*/
  }
  .delivery_border_img{
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }
  .delivery_border_title{
    margin-top: 10px;
    font-size: 1.25em;
    font-weight: normal;
  }
  .delivery_border_content{
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: normal;
  }
  .fruit_img{
    height: 550px;width: 100%;
  }
  .fruit_product_img{
    height: 500px;
    width: 260px;
  }
  .deliver_parent{
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .deliver_img_parent{
    width: 30%;
    height: auto;
  }
  .delivery{
    display: flex;
    height: 550px;
    width: 90%;
    margin: auto;
    justify-content: center;
    align-items: center;
  }
  /* 屏幕设备适配 max-device-width: 400px */
  @media screen and (max-device-width: 415px){
    .fruit_img{
      height: 250px;width: 100%;
    }
    .fruit_product_img{
      height: 400px;
      width: 240px;
    }
    .delivery_border_img{
      margin-top: 20px;
      width: 70px;
      height: 70px;
    }
    .deliver_img_parent{
      width: 100%;
      float: left;
      height: 400px;
    }
    .deliver_parent{
      float: left;
      margin-top: 5px;
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .delivery_border{
      height: auto;
      margin:10px 0 auto;
      width: 100%;
      float: right;
      border-radius: 6px;
      border: 1px solid #EBEEF5;
    }
    .delivery{
      display: flex;
      width: 90%;
      height: auto;
      margin: auto;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .delivery_border_title{
      margin-top: 5px;
      font-size: 1.125em;
      font-weight: normal;
    }
    .delivery_border_content{
      margin-top: 5px;
      font-size: 1.125em;
      font-weight: normal;
      margin-bottom: 10px;
    }
  }
</style>